import React from 'react';

interface TrendLineProps {
    data: number[];
    color: 'brand' | 'success' | 'warning' | 'danger';
    width?: number;
    height?: number;
}

export const TrendLine: React.FC<TrendLineProps> = ({ 
    data, 
    color,
    width = 64,
    height = 32 
}) => {
    const colorMap = {
        brand: '#2563EB',
        success: '#10B981',
        warning: '#F59E0B',
        danger: '#EF4444',
    };

    if (data.length < 2) return null;

    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;

    const points = data.map((val, i) => {
        const x = (i / (data.length - 1)) * width;
        const y = height - ((val - min) / range) * height;
        return `${x},${y}`;
    }).join(' ');

    return (
        <svg width={width} height={height} className="overflow-visible">
            <defs>
                <linearGradient id={`gradient-${color}`} x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={colorMap[color]} stopOpacity="0.3" />
                    <stop offset="100%" stopColor={colorMap[color]} stopOpacity="0" />
                </linearGradient>
            </defs>
            
            <polygon
                points={`0,${height} ${points} ${width},${height}`}
                fill={`url(#gradient-${color})`}
            />
            
            <polyline
                points={points}
                fill="none"
                stroke={colorMap[color]}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};